import { X } from "lucide-react";
import useAuth from "../../hooks/useAuth";

const ApprovedAmount = ({
  closeLoanAmount,
  handleFinalizeApproval,
  approvalDetails,
  setApprovalDetails,
}) => {
  const { auth } = useAuth();
  const isSuperAdmin = auth?.user?.role?.name === "Super Admin";

  const handleAmountChange = (e) => {
    const value = e.target.value;
    setApprovalDetails((prev) => ({
      ...prev,
      approvalAmount: value,
    }));
  };
  return (
    <div
      onClick={(e) => {
        closeLoanAmount();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[800px] h-[500px] rounded-[10px] py-[20px] px-[40px] relative bg-white"
      >
        <div
          onClick={closeLoanAmount}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div>
          <p className="text-[#000000] font-semibold text-[20px]">
            Approve Loan Amount
          </p>
          <p className="text-[#5C5C5C] font-normal text-[14px]">
            Review the requested loan amount and decide whether to approve it in
            full or adjust it based on eligibility.
          </p>
          <div className="flex my-[20px] w-[100%] flex-col">
            <label
              className="text-[#222222] font-medium text-[13px]"
              htmlFor="Loan Amount (KES)"
            >
              Loan Amount (KES)
            </label>
            <input
              className="h-[45px] w-full text-[14px] rounded-[5px] px-[10px] border border-[#D9D9D9] focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-[#D9D9D9]"
              placeholder="e.g 200,000"
              type="text"
              value={approvalDetails.approvalAmount}
              onChange={handleAmountChange}
              readOnly={!isSuperAdmin}
            />
          </div>
        </div>
        <div className="absolute bottom-[20px] right-[20px] flex items-center justify-center gap-[10px]">
          <button
            onClick={closeLoanAmount}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
          >
            Close
          </button>
          <button
            onClick={handleFinalizeApproval}
            className="h-[35px] bg-[#000000] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApprovedAmount;
